import React, { useContext, useState } from "react";
import "ui/UI.css";
import DatabaseContext from "data/contextDatabase";
import GlobalContext from "contexts/context";
import EXIF from "exif-js";
import { isMobileTablet } from "hooks/helper";

const UIMessageSend = (props) => {
  const { databaseState, databaseDispatch } = useContext(DatabaseContext);
  const { globalState } = useContext(GlobalContext);

  const isMobileTabletCheck = isMobileTablet();

  const randomString = (length) => {
    let result = "";
    let characters =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  const sendMessage = (message, canvas) => {
    let t = canvas
      .toDataURL()
      .replace(/^data:image.+;base64,/, "")
      .replace(/^data:,/, "");
    let m = t === "" ? message : message === "" ? " " : message;
    let j;
    if (props.mdialog !== undefined) {
      j = {
        type: "w.mpersona.message",
        content: { body: m, msgtype: "w.text" },
        mpersona: props.mpersona,
        peer: props.peer,
        visibility: "PRIVATE_DIALOG",
        name: props.name,
        ts_sender: "",
        smid: randomString(8),
        status: "1",
        origin_sender: "registered",
        thumbnail: t,
        lat: "",
        lon: "",
        persona_picture: "",
        version: globalState.version,
      };
      if (props.tag !== undefined && props.tag !== "") {
        j.tag = props.tag;
      }
      if (
        props.topic_display_name !== undefined &&
        props.topic_display_name !== ""
      ) {
        j.topic_display_name = props.topic_display_name;
      }
    } else if (props.mtopic !== undefined) {
      j = {
        type: "w.topic.message",
        content: { body: m, msgtype: "w.text" },
        persona: props.persona,
        name: props.name,
        mtopic: props.mtopic,
        topic: props.topic,
        ts_sender: "",
        smid: randomString(8),
        status: "1",
        origin_sender: "registered",
        thumbnail: t,
        version: globalState.version,
        lat: "",
        lon: "",
        persona_picture: "",
      };
    }

    databaseDispatch({
      type: "UPSERT_REC",
      values: {
        jmessage: j,
        db: databaseState.dbMaster,
        collection: "send",
        table: "confirm_smid",
        rowid: j.smid,
        doc: j,
      },
    });
    canvas.height = 0;
    canvas.width = 0;
  };

  let msg_text = "";

  const orientation = (img) => {
    return new Promise(function (resolve, reject) {
      EXIF.getData(img, () => {
        var allMetaData = EXIF.getAllTags(img);
        console.log("allMetaData: ", allMetaData);
        let orientation = allMetaData.Orientation;
        // alert("orientation: " + orientation);
        resolve(orientation);
      });
    });
  };

  const processImage = (file) => {
    document.getElementById("select_image_div").style.display = "block";
    var img = new Image();
    img.onload = async () => {
      var canvas = document.getElementById("canvas");
      var ctx = canvas.getContext("2d");
      var maxW = 250;
      var maxH = 250;
      var iw = img.width;
      var ih = img.height;
      var exifOrientation = "";
      // Bypassing use of orientation by adding 20 ...
      exifOrientation = 20 + (await orientation(img));
      console.log("Exif orientation: " + exifOrientation);
      let scale = 1;
      if (iw > maxW || ih > maxH) {
        scale = Math.min(maxW / iw, maxH / ih);
      }
      var iwScaled = Math.round(iw * scale);
      var ihScaled = Math.round(ih * scale);
      if ([5, 6, 7, 8].indexOf(exifOrientation) > -1) {
        canvas.width = ihScaled;
        canvas.height = iwScaled;
      } else {
        canvas.width = iwScaled;
        canvas.height = ihScaled;
      }
      switch (exifOrientation) {
        case 2:
          ctx.setTransform(-1, 0, 0, 1, iwScaled, 0);
          break;
        case 3:
          ctx.setTransform(-1, 0, 0, -1, iwScaled, ihScaled);
          break;
        case 4:
          ctx.setTransform(1, 0, 0, -1, 0, ihScaled);
          break;
        case 5:
          ctx.setTransform(0, 1, 1, 0, 0, 0);
          break;
        case 6:
          ctx.setTransform(0, 1, -1, 0, ihScaled, 0);
          break;
        case 7:
          ctx.setTransform(0, -1, -1, 0, ihScaled, iwScaled);
          break;
        case 8:
          ctx.setTransform(0, -1, 1, 0, 0, iwScaled);
          break;
        default:
          ctx.setTransform(1, 0, 0, 1, 0, 0);
      }
      ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
    };
    img.src = file;
  };

  const onImageSelect = (event) => {
    event.target.files[0] &&
      processImage(URL.createObjectURL(event.target.files[0]));
  };

  let divImage = (
    <div id="select_image_div" style={{ display: "none" }}>
      <div>
        <div className="UI-imgcontainer">
          <span
            onClick={() => {
              document.getElementById("canvas").height = 0;
              document.getElementById("canvas").width = 0;
              document.getElementById("select_image_div").style.display =
                "none";
              document.getElementById("input_image_select").value = "";
            }}
            className="UI-modal-close"
            title="Cancel"
          >
            &times;
          </span>
          <canvas id="canvas" width="0" height="0"></canvas>
        </div>

        {/* <div className="UI-login-container">
          <div>
            <input
              id="input_image_select"
              type="file"
              accept="image/*"
              onChange={onImageSelect}
            />
          </div>
        </div> */}
      </div>
    </div>
  );

  let content = (
    <div className="UI-message-area">
      {divImage}
      <div className="UI-message-input">
        <textarea
          className="UI-input"
          type="message"
          placeholder="Enter message"
          name="message"
          required
          id="msg_text"
          onChange={() => {
            msg_text = document.getElementById("msg_text").value;
          }}
          onKeyUp={(e) => {
            if (e.keyCode == 13 && e.shiftKey) {
              e.preventDefault();
              document.getElementById("msg_send_button").click();
            }
          }}
        />

        <div className="UI-message-buttons">
          <button
            onClick={() => {
              document
                .getElementById("input_image_select")
                .removeAttribute("capture");
              document.getElementById("input_image_select").click();
            }}
            className="UI-button-icon"
            type="image"
          ></button>

          <button
            style={{ display: isMobileTabletCheck ? "" : "none" }}
            onClick={() => {
              document
                .getElementById("input_image_select")
                .setAttribute("capture", "environment");
              document.getElementById("input_image_select").click();
            }}
            className="UI-button-icon"
            type="photo"
          ></button>
          <input
            id="input_image_select"
            type="file"
            accept="image/*"
            onChange={onImageSelect}
            style={{ display: "none" }}
          />

          <button
            id="msg_send_button"
            className="UI-button-icon"
            type="send"
            onClick={() => {
              sendMessage(msg_text, document.getElementById("canvas"));
              document.getElementById("msg_text").value = "";
              document.getElementById("canvas").height = 0;
              document.getElementById("canvas").width = 0;
              document.getElementById("select_image_div").style.display =
                "none";
              document.getElementById("input_image_select").value = "";
            }}
          ></button>
        </div>
      </div>
    </div>
  );

  return content;
};

export default React.memo(UIMessageSend, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
